import { makeStyles, Typography, Box, Grid } from "@material-ui/core";

import { Icon } from "../../../../../components/base/Icon";
import StreamIcon from "../../../../../assets/images/icons/map/stream.png";
import { StatusBox } from "../../../../../components/boxes/StatusBox";

const useStyles = makeStyles(() => ({
  root: {
    position: "relative",
  },
  status: {
    position: "absolute",
    top: 15,
    left: 15,
  },
  stream: {
    width: "100%",
  }
}))

export const Stream = ({ status }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Grid container className={classes.status}>
        <Typography variant="body2" style={{ marginRight: 5 }}>
          Status:
        </Typography>
        <StatusBox
          status={status}
        />
      </Grid>
      <Icon src={StreamIcon} root={classes.stream}/>
    </Box>
  )
}
